import * as React from "react";

const SvgAutoLink = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m9.3 22-.4-3.2a4 4 0 0 1-.613-.3 8 8 0 0 1-.562-.375l-2.975 1.25L2 14.625l2.575-1.95a2.4 2.4 0 0 1-.025-.338v-.675q0-.162.025-.337L2 9.375l2.75-4.75 2.975 1.25Q8 5.675 8.3 5.5t.6-.3L9.3 2h5.5l.4 3.2q.325.125.613.3.287.175.562.375l2.975-1.25 2.75 4.75-1.85 1.4a8 8 0 0 0-1.125-.463 6.3 6.3 0 0 0-1.225-.262l1.575-1.2-.975-1.7-2.475 1.05a5.6 5.6 0 0 0-1.212-.962 5.6 5.6 0 0 0-1.438-.588L13.05 4h-1.975l-.35 2.65q-.775.2-1.437.587-.663.388-1.213.938L5.6 7.15l-.975 1.7 2.15 1.6q-.125.375-.175.75t-.05.8q0 .4.05.775t.175.75l-2.15 1.625.975 1.7 2.475-1.05q.425.425.913.762.488.338 1.062.563.025 1.425.587 2.675.563 1.25 1.513 2.2zm1.025-6.975q.15-.5.363-.963.212-.462.487-.887a1.34 1.34 0 0 1-.425-.513q-.15-.312-.15-.662 0-.625.438-1.062A1.45 1.45 0 0 1 12.1 10.5q.35 0 .675.162.325.163.525.438.425-.275.875-.487.45-.213.95-.338a3.5 3.5 0 0 0-1.25-1.287A3.35 3.35 0 0 0 12.1 8.5q-1.475 0-2.487 1.025A3.4 3.4 0 0 0 8.6 12q0 .95.463 1.762.462.813 1.262 1.263m8.725 3.825-.7.7-2.15-2.15v-2.7h1V17zm1.5-1.85a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m1.5 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAutoLink;
